module.exports = __webpack_public_path__ + "static/media/img8.3b8ac2c9.jpg";